/**
 * Debounce function
 *
 * @param {Function} func function to invoke
 * @param {number} delay miliseconds
 * @returns {Function} callback function
 */
function debounce(func, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, arguments), delay);
  };
}

/**
 * Remove old popup
 *
 */
function updatePopup() {
  const node = document.querySelector('at-newsletter-modal');
  const id = node.querySelector('modal-opener').getAttribute('data-modal');
  const modal = document.querySelector(`modal-dialog${id}`);
  if (modal) modal.remove();
  const clone = node.cloneNode(true);
  node.parentNode.replaceChild(clone, node);
}

/**
 * Update actions in design mode
 *
 */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:unload', debounce(updatePopup, 1000));
}

if (!customElements.get('at-newsletter-modal')) {
  customElements.define(
    'at-newsletter-modal',
    class NewsletterModal extends HTMLElement {
      constructor() {
        super();

        let cookieEnabled = navigator.cookieEnabled;
        if (!cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
        }

        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !cookieEnabled) {
          return;
        }

        if (Shopify.designMode && this.testMode) {
          this.load(1);
        }

        this.init();
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }

      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }

      get cookieName() {
        return 'wuber:newsletter-popup';
      }

      get submited() {
        const id = this.querySelector('modal-opener').getAttribute('data-modal');
        const modal = document.querySelector(`modal-dialog${id}`);
        if (!modal) return null;
        if (!window.location.hash.includes('newsletter-popup')) return null;

        return modal.querySelector('.form__message') !== null;
      }

      init() {
        if (Shopify.designMode) return;

        if (this.initialized) return;
        this.initialized = true;

        // Open modal if errors or success message exist
        // if (this.submited) {
        //   this.load(1);
        //   return;
        // }

        // Set cookie without opening modal again
        if (!this.testMode && window.location.href.includes('?customer_posted=true#newsletter-popup')) {
          this.setCookie(this.cookieName, this.expiry);
          return;
        }

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
          return;
        }
      }

      load(delay) {
        setTimeout(() => {
          // open modal
          this.querySelector('button').click();

          // invoke afterHide
          const id = this.querySelector('modal-opener').getAttribute('data-modal');
          const modal = document.querySelector(`modal-dialog${id}`);
          if (modal) {
            modal.addEventListener('click', (e) => {
              if (e.target === e.currentTarget) this.afterHide();
            });
            const modalButton = modal.querySelector(`.at-newsletter-popup-modal__toggle`);
            modalButton.addEventListener('click', () => this.afterHide());
          }
        }, delay * 1000);
      }

      afterShow() {}

      afterHide() {
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }

      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
